import api from "@/lib/api";

// What an employee types to open a protected payslip. Mirrors backend services/payslip_password.py.
export const PAYSLIP_PASSWORD_HINT =
  "This payslip PDF is password protected. The password is your birth date as MMDDYYYY (for example 01151990), or your employee number if no birth date is on file.";

export async function downloadPayslipPdf(itemId, path = `/me/payslips/${itemId}/pdf`) {
  // The payroll side passes /payroll/items/<id>/payslip/pdf: the same file, the same password rule.
  const r = await api.get(path, { responseType: "blob" });
  const url = URL.createObjectURL(r.data);
  const a = document.createElement("a");
  const m = /filename=([^;]+)/.exec(r.headers?.["content-disposition"] || "");
  a.href = url;
  a.download = m ? m[1].replace(/"/g, "") : "payslip.pdf";
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
  return r.headers?.["x-payslip-protected"] === "yes";
}

// A blob error body is a Blob; read the server's message out of it.
export async function pdfErrorMessage(e) {
  try {
    const t = await e.response.data.text();
    return JSON.parse(t).detail || "Could not download the payslip";
  } catch {
    return "Could not download the payslip";
  }
}
